module.exports = __webpack_public_path__ + "static/media/ico_footer_list_on.73833c42.png";